import React from 'react';
import classNames from 'classnames';
import pt from 'prop-types';

import Icon from 'components/icon';

import DropdownButton from './dropdown';

import './button.scss';

export default class KebabButton extends React.PureComponent {
  static propTypes = {
    className: pt.string,
  };

  render() {
    const { className } = this.props;

    return (
      <DropdownButton
        side="top"
        type="inline"
        {...this.props}
        className={classNames('button-dropdown-kebab', className)}
        arrow={false}
      >
        <Icon fa="ellipsis-h" />
      </DropdownButton>
    );
  }
}
